export default "__VITE_ASSET__B$GBoLb6__"